<template>
  <div class="main-form">
    <h2 class="text mt-3 mb-5">{{ $t("anmobi.login.connectezvous") }}</h2>

    <div class="form">
      <b-form-group
        label="Dossier:"
        label-cols-xs="4"
        label-cols-sm="4"
        label-cols-md="4"
        label-cols-lg="4"
      >
        <b-form-input v-model="infoDossier" readonly></b-form-input>
      </b-form-group>
      <b-form-group
        label="Nom d'utilisateur:"
        label-cols-xs="4"
        label-cols-sm="4"
        label-cols-md="4"
        label-cols-lg="4"
      >
        <b-form-input
          v-model="user.username"
          required
          placeholder="Entrez votre nom d'utilisateur"
          :disabled="listUsers.length === 0"
        ></b-form-input>
      </b-form-group>

      <!-- Champs password -->
      <b-form-group
        label="Code PIN:"
        label-cols-xs="4"
        label-cols-sm="4"
        label-cols-md="4"
        label-cols-lg="4"
      >
        <b-input-group>
          <b-form-input
            :class="{'input-pin' : isPasswordVisible}"
            v-model="user.password"
            type="text"
            required
            placeholder="Entrez votre code PIN"
            :disabled="listUsers.length === 0"
          ></b-form-input>

          <b-button
            class="btn-show w-25"
            variant="info"
            v-touch:tap="switchPasswordVisibility"
          >
            <div class="h5 mb-0">
              <b-icon-eye-fill v-if="isPasswordVisible"> </b-icon-eye-fill>
              <b-icon-eye-slash-fill v-else> </b-icon-eye-slash-fill>
            </div>
          </b-button>
        </b-input-group>
      </b-form-group>
    </div>

    <b-alert
      class="p-2 mx-auto error-alert"
      variant="danger"
      show
      v-if="alertMsg"
    >
      {{ alertMsg }}
    </b-alert>
    <b-button
      class="p-2 mx-auto error-alert"
      variant="warning"
      @click="$emit('refresh-config')"
      v-if="alertMsg.includes(`L'utilisateur n'a aucune activité !`)"
    >
      Actualiser l'application
    </b-button>
    <b-alert
      class="p-2 mx-auto error-alert"
      variant="danger"
      show
      v-if="error.length !== 0"
    >
      {{ error }}
    </b-alert>

    <span class="btn-group-submit">
      <button
        class="btn btn-valider"
        v-touch:tap="submit"
        :disabled="listUsers.length === 0"
      >
        {{ $t("anmobi.login.valider") }}
      </button>
    </span>
  </div>
</template>

<script type="ts">
import { Vue } from "vue-property-decorator";
import { BIconEyeFill, BIconEyeSlashFill } from "bootstrap-vue";
import api from "@/http/api"; 

export default Vue.extend({
  props: {
    username: {
      type: String,
      default: null,
    },
    alertMsg: {
      type: String,
      default: "",
    },
    listUsers: {
      type: Array,
    },
    nomDossier: {
      type: String,
      default: "",
    },
    envDossier: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      user: {
        username: "",
        password: "",
      },

      type: "password",
      error: "",
      infoDossier: this.nomDossier + " " + this.envDossier,
    };
  },
  components: { BIconEyeFill, BIconEyeSlashFill },
  computed: {
    isPasswordVisible() {
      return this.type === "password";
    },
  },

  methods: {
    submit() {
      this.$emit("submit", this.user);
    },

    switchPasswordVisibility() {
      this.type = this.isPasswordVisible ? "text" : "password";
    },
    showError() {
      this.showAlert = true;
    },

    reset(evt) {
      this.showAlert = false;
      evt.preventDefault();
      // Reset our form values
      //this.user.username = ''
      this.user.password = "";
      this.$nextTick(() => {
        this.show = true;
      });
      this.$emit("reset", evt);
    },
    async checkClusterUpgrade() {
      console.log("Vérification de la mise à jour du cluster...");
      const idDossier = localStorage.getItem("idDossier");
      const localCluster = localStorage.getItem("cluster");
      if (idDossier) {
       await api.infoController.getClusterInfo(idDossier)
          .then(resp => {
            let apiCluster = '';
            if(resp.data && resp.data.cluster) {
              apiCluster = resp.data.cluster;
            }
            if (apiCluster && localCluster && apiCluster !== localCluster || apiCluster == null) {
              const upgradeDoc = {
                _id: "upgrade",
                idDossier: idDossier,
                oldCluster: localCluster,
                newCluster: apiCluster,
                date: new Date().toISOString(),
                typedoc: "upgrade"
              };
               db.put(upgradeDoc);
            }
          })
          .catch(() => {
            console.error("Impossible de vérifier le cluster du serveur.");
          });
      }
    },
  },
  mounted() {
    console.log("Mounted exécuté !");
    this.checkClusterUpgrade();

    this.user.username = this.username;
    if (this.listUsers.length === 0) {
      this.user = {
        username: "",
        password: "",
      };
      this.error =
        "Aucun utilisateur trouvé. Vérifiez si une synchronisation a déjà eu lieu, depuis la création de celui ci.";
    }
  },
  watch: {
    '$route'(to, from) {
      this.checkClusterUpgrade();
    },
    nomDossier(newVal, oldVal) {
      this.infoDossier = this.nomDossier + " " + this.envDossier;
    },
  },
});
</script>
<style lang="scss" scoped>
.main-form {
  max-width: 600px;
  width: 100%;
  padding: 0 20px;
  margin: 0 auto;
  margin-top: 15vh;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #c9bad2;
  color: black;
  font-weight: bold;
  cursor: not-allowed;
  opacity: 1;
}
.btn-valider {
  background-color: #663682;
  border: solid 1px white;
  font-weight: bold;
  border-radius: 12px;
  color: white;
  padding: 5px 40px;
  margin: 6px;
  font-size: 1.2rem;
}

.btns {
  img {
    width: 50px;
    margin: 10px;
  }
}

.text {
  font-weight: bold;
  font-size: 1.4em;
  color: #663c82;
  text-align: center;
}
.form {
  text-align: left;
  font-weight: bold;
  font-size: 1.2rem;
}

.container i {
  margin-left: -30px;
  cursor: pointer;
}
.btn-show {
  font-weight: bold;
  color: #663c82;
  padding: 2px;
}
.error-alert {
  font-weight: bold;
  font-size: 1em;
  border-radius: 12px;
  color: #663c82;
}

.input-pin {
  -webkit-text-security: disc;
}
@include media-breakpoint-up(sm) {
  .main-form {
    margin-top: 20vh;
  }
}
@include media-breakpoint-up(md) {
}
@include media-breakpoint-up(lg) {
}
@include media-breakpoint-up(xl) {
}
</style>